import React from "react";
import AddModuleModal from "../Modal/AddModuleModal";
import EditModuleModal from "../Modal/EditModuleModal";
import ConfirmationModal from "../Modal/ConfirmationModal";

const DO_NOTHING = ()=>{};

export default function TestCasePopupsWrapper({popUpData={}}) {
    const { title='', show=false, closePopup=DO_NOTHING, errorFunction=DO_NOTHING, successFunction=DO_NOTHING, confirmationFunction=DO_NOTHING, data={}, message='' } = popUpData;
    
    const renderPopups = () => {
        switch (popUpData.type) {
            case 'addmodule':
            case 'addChildmodule':    
                return (
                    <AddModuleModal
                        isOpen={show}
                        title={title}
                        onClose={closePopup}
                        onConfirm={confirmationFunction}
                    />
                )
                break;
            case 'editModule':
                return (
                    <EditModuleModal
                        isOpen={show}
                        onClose={closePopup}
                        onConfirm={confirmationFunction}
                        nodeName={data.name}
                        context={data.context}
                        title={title}
                    />
                )
                break;
            case 'deleteModule':
                return (
                    <ConfirmationModal
                        open={show}
                        onClose={closePopup}
                        onConfirm={confirmationFunction}
                        title={title}
                        message={message}
                    />
                )
                break;
            default:
                return null;        
        }
    }

    return (
        <>
           {renderPopups()}
        </>
    )
}